import { useMsal } from "@azure/msal-react";
import React from "react";
import { loginRequest } from "../auth/authConfig";
import { toast } from "react-toastify";
import errorNotification from "../Components/Notification/errorNotification";
import successNotification from "../Components/Notification/successNotification";
import { postmortemApiEndpoint } from "../config";
import { PostWithRetry } from "./postWithRetry";
import { fetchToken } from "../services/fetchTokenService";
import { getConsumerKey } from "../services/maerskApiTokenService";

function UseHandleFileUpload(
  images,
  setError,
  setErrorMessage,
  photosFor,
  hanldePreviewModal,
  setImageToPreview,
  dispatch,
  imageFormData,
  imagesFor,
  setFetchAgain,
  incidentID
) {
  const { instance, accounts } = useMsal();
  const { postWithRetry } = PostWithRetry();

  const handleFiles = (event) => {
    if (event.actionItem.action === "preview") {
      previewImage(event.file);
    } else if (event.actionItem.action === "delete") {
      deleteImage(event.file, event.file.photoFor);
    } else {
      //download file
      const url = event.file.preview;

      // Create an anchor element to trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = event.file.name;

      // Trigger a click event on the anchor element to initiate the download
      a.click();

      // Clean up by revoking the URL
      URL.revokeObjectURL(url);
    }
  };

  const fileChange = (data) => {
    //check if image already exist in context
    let file = {};

    if (data.event && data.event.dataTransfer) {
      file = data.event.dataTransfer.files[0];
    } else {
      file = data.event.target.files[0];
    }

    // Skip duplicate check - backend will handle it
    // Old check was: images[imagesFor][data.photoFor].some((image) => image.name === file.name)
    // Since we're doing immediate upload, this check is no longer needed

    // Upload image immediately
    uploadImageImmediately(file, data.photoFor);
  };

  const uploadImageImmediately = async (file, photoFor) => {
    console.log('[UseHandleFileUpload] uploadImageImmediately called with file:', file.name, 'photoFor:', photoFor, 'incidentID:', incidentID);
    if (!incidentID) {
      errorNotification("Incident ID is required to upload images");
      return;
    }

    const toastId = toast.loading("Uploading image...", {
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
    });

    try {
      const formData = new FormData();
      formData.append("images", file);

      const tags = JSON.stringify([{ tag: photoFor, images: [file.name] }]);
      const uploadUrl = postmortemApiEndpoint + `/images-upload?incidentNumber=${encodeURIComponent(incidentID)}&tagsWithImages=${encodeURIComponent(tags)}`;
      console.log('[UseHandleFileUpload] Upload URL:', uploadUrl);

      await postWithRetry(uploadUrl, formData);

      toast.update(toastId, {
        render: "Image uploaded successfully",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      successNotification("Image saved successfully");
      console.log('[UseHandleFileUpload] Image uploaded successfully, toggling fetchAgain');
      setFetchAgain((prev) => {
        console.log('[UseHandleFileUpload] setFetchAgain called, prev:', prev, 'new:', !prev);
        return !prev;
      });
    } catch (error) {
      console.error("Error uploading image:", error);
      toast.update(toastId, {
        render: "Error uploading image",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      errorNotification("Error uploading image. Please contact admin.");
    }
  };

  //======================================================================================

  //Adding Image data to Context
  //======================================================================================

  const addImageDataToContext = (data, photoFor) => {
    let fileData = {};
    if (data.dataTransfer) {
      fileData = data.dataTransfer.files[0];
    } else {
      fileData = data.target.files[0];
    }
    // const fileData = data.target.files[0];
    const file = {
      lastModified: fileData.lastModified,
      name: fileData.name,
      size: fileData.size,
      type: fileData.type,
      webkitRelativePath: fileData.webkitRelativePath,
      uploaded: false,
      preview: URL.createObjectURL(fileData),
    };
    dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "images",
      payload: {
        ...images,
        [imagesFor]: {
          ...images[imagesFor],
          [photoFor]: [...images[imagesFor][photoFor], file],
        },
      },
    });
  };

  const addImageFormDataToContext = (imageData, photoFor) => {
    let data = imageFormData[photosFor];

    let imageFileData = {};
    if (imageData.dataTransfer) {
      imageFileData = imageData.dataTransfer.files[0];
    } else {
      imageFileData = imageData.target.files[0];
    }

    data.append("images", imageFileData);
    dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "imageFormData",
      payload: {
        ...imageFormData,

        [photoFor]: data,
      },
    });
  };

  //======================================================================================

  //Delete Image Data from Context

  const deleteImage = (file, deleteImageFor) => {
    if (file.uploaded) {
      deleteImagefromDatabase(file, deleteImageFor);
      return;
    }

    deleteImageInContext(file.name, deleteImageFor);
    // setFiles((files) => files.filter((fil) => fil.name !== file.name));
    deleteImageFormDataInContext(file.name, deleteImageFor);
    // setPhotosFor(deleteImageFor)
  };

  const deleteImageInContext = (fileName, deleteImageFor) => {
    dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "images",
      payload: {
        ...images,
        [imagesFor]: {
          ...images[imagesFor],
          [deleteImageFor]: images[imagesFor][deleteImageFor].filter(
            (file) => file.name !== fileName
          ),
        },
      },
    });
  };

  const deleteImageFormDataInContext = (fileName, deleteImageFor) => {

    let formData = imageFormData[deleteImageFor];
    let newFormData = new FormData();
    for (const pair of formData.entries()) {
      const [key, value] = pair;
      if (value.name !== fileName) {
        newFormData.append(key, value); // Append only non-matching entries
      } 
    }

  
    dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "imageFormData",
      payload: {
        ...imageFormData,

        [deleteImageFor]: newFormData,
      },
    });
  };

  //Preview Image
  const previewImage = (file) => {
    hanldePreviewModal();
    setImageToPreview(() => ({
      preview: file.preview,
      fileName: file.name,
    }));
  };

  const deleteImagefromDatabase = (file, deleteImageFor) => {

    const api = postmortemApiEndpoint;

    toast("Deleting Image please wait", {
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      type: "success",
    });

    (async () => {
      try {
        const tokenResponse = await fetchToken(instance, loginRequest, accounts);
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${tokenResponse.idToken}`);
        myHeaders.append("Consumer-Key", getConsumerKey());

        var raw = JSON.stringify([file.name]);

        var requestOptions = {
          method: "DELETE",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          api + `/images-delete?incidentNumber=${incidentID}&tags=${deleteImageFor}`,
          requestOptions
        );
        if (response.status !== 200 && response.status !== 201) {
          toast.dismiss();
          toast("Unable to delete image please contact admin", {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "error",
          });
        } else {
          toast.dismiss();
          toast("Image Deleted", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        }
        setFetchAgain((fetchAgain) => !fetchAgain);
      } catch (error) {
        console.log("error", error);
      }
    })();
  };

  return {
    handleFiles,
    fileChange,
    deleteImage,
    previewImage,
  };
}

export default UseHandleFileUpload;
